import DashboardAcceptedQuotesHtml from './templates/dashboard.accepted-quotes.html';
import DashboardJobsHtml from './dashboard.jobs.html';
import DashboardTransactionsHtml from './dashboard.transactions.html';
import DashboardTiremetrixHtml from './dashboard.tiremetrix.html';
import DashboardWorkingMechanicsHtml from './dashboard.working-mechanics.html';
import VehicleRegistrationLookupsHtml from './templates/dashboard.vehicle-registration.lookups.html';

export function Dashboard(
  $filter,
  $q,
  $rootScope,
  $state,
  $translate,
  $window,
  API,
  businessIntelligenceApi,
  companyApi,
  GoogleCharts,
  jsonApi,
  PRODUCTTYPES,
  sessionObjAPI,
  workshopAPI
) {
  var Dashboard = function (settings, businessIntelligenceDashboards = {}) {
    this.Company = companyApi;

    this.businessIntelligenceDashboards = businessIntelligenceDashboards;

    this.widgets_include_tax = jsonApi.parse(localStorage.getItem('dashboardTaxSwitch')) === false ? false : true;
    this.widgets_mtd = jsonApi.parse(localStorage.getItem('dashboardMTDSwitch')) === false ? false : true;

    this.tabs = [];

    this.builds = {
      bookings   : buildBookingsReport,
      hours      : buildHoursReport,
      products   : buildProductsReport,
      performance: buildPerformanceReport,
      sales      : buildSalesReport
    };

    this.jasperRoutes = {
      rego   : `${API.url}/reports/jasper_rego_renewal`,
      sales  : `${API.url}/reports/jasper_simple_sales_report`,
      service: `${API.url}/reports/service_due`
    };

    this.routes = {
      bookings   : '/dashboard/bookings_and_jobs',
      hours      : '/dashboard/mechanic_hours',
      products   : '/dashboard/sales_breakup_report',
      performance: '/dashboard/mechanic_performance',
      sales      : '/dashboard/weekly_sales_report'
    };

    this.activity = [
      {
        active : true,
        content: DashboardTransactionsHtml,
        title  : $translate.instant('JS_SPACE.TABS.TRANSACTIONS')
      }
    ];

    if (settings) {
      if (settings.has_workshop) {
        this.activity.push({
          active : false,
          content: DashboardWorkingMechanicsHtml,
          title  : $translate.instant('JS_SPACE.TABS.JOBS_IN_PROGRESS')
        });

        this.activity.push({
          active : false,
          content: DashboardJobsHtml,
          title  : $translate.instant('JS_SPACE.TABS.RECENTLY_COMPLETED')
        });

        if (settings.tiremetrix_settings.has_tiremetrix_tire_registration) {
          this.activity.push({
            active : false,
            content: DashboardTiremetrixHtml,
            title  : $translate.instant('TIREMETRIX_SPACE.TYRES_NOT_REGISTERED')
          });
        }
      }

      if ( this.Company.hasIntegration('carfax') || this.Company.hasIntegration('dvla-lookup') || this.Company.hasIntegration('vehicle-registrations') ) {
        this.activity.push({
          active : false,
          content: VehicleRegistrationLookupsHtml,
          title  : $translate.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.TITLE')
        });
      }

      if (this.Company.hasIntegration('customer-portal')) {
        this.activity.push({
          active : false,
          content: DashboardAcceptedQuotesHtml,
          title  : $translate.instant('CUSTOMER_SPACE.CUSTOMER_PORTAL.ACCEPTED_QUOTES')
        });
      }

      if (this.Company.hasIntegration('business-intelligence')) {
        this.tabs = [
          {
            active : false,
            heading: $translate.instant('DASHBOARD_SPACE.BUSINESS_INTELLIGENCE.HOME'),
            id     : 'home'
          },
          {
            active     : false,
            dashboardId: this.businessIntelligenceDashboards.overview.dashboard_id,
            heading    : $translate.instant('DASHBOARD_SPACE.BUSINESS_INTELLIGENCE.OVERVIEW'),
            id         : 'bi-overview'
          },
          {
            active     : false,
            dashboardId: this.businessIntelligenceDashboards.customer.dashboard_id,
            heading    : $translate.instant('DASHBOARD_SPACE.BUSINESS_INTELLIGENCE.CUSTOMERS'),
            id         : 'bi-customers'
          },
          {
            active     : false,
            dashboardId: this.businessIntelligenceDashboards.vehicle.dashboard_id,
            heading    : $translate.instant('DASHBOARD_SPACE.BUSINESS_INTELLIGENCE.VEHICLES'),
            id         : 'bi-vehicles'
          },
          {
            active     : false,
            dashboardId: this.businessIntelligenceDashboards.product.dashboard_id,
            heading    : $translate.instant('DASHBOARD_SPACE.BUSINESS_INTELLIGENCE.PRODUCTS'),
            id         : 'bi-products'
          },
          {
            active     : false,
            dashboardId: this.businessIntelligenceDashboards.snapshot.dashboard_id,
            heading    : $translate.instant('DASHBOARD_SPACE.BUSINESS_INTELLIGENCE.SNAPSHOT'),
            id         : 'bi-snapshot'
          }
        ];
      }
      else {
        if (settings.has_workshop) {
          this.tabs.push({
            active : false,
            heading: $translate.instant('MENU_SPACE.REPORTS.SALES'),
            id     : 'sales'
          });
        }
      }

      if (settings.has_autoinspect) {
        this.tabs.push({
          active : false,
          heading: $translate.instant('INSPECTIONS_SPACE.INSPECTIONS'),
          id     : 'inspections'
        });
      }

      if (settings.has_dealership) {
        this.tabs.push({
          active : false,
          heading: $translate.instant('DEALERSHIP_SPACE.DEALERSHIP'),
          id     : 'dealership'
        });
      }

      // assign initial tab.
      const tabId = this.Company.hasIntegration('business-intelligence') ? 'home' : (
        settings.has_workshop ? 'sales' : (
          settings.has_autoinspect ? 'inspections' : 'dealership'
        )
      );

      this.tab = this.tabs.filter(tab => tab.id === tabId)[0] || {};

      this.tab.active = true;
    }
  };

  var batchSize = 8;
  var googleCharts = new GoogleCharts();

  var buildBookingsReport = function (bookingsReport) {
    var cols = [
      { id: 'bookings', label: $translate.instant('JS_SPACE.DASHBOARD.LABEL.BOOKINGS'), type: 'number' },
      { id: 'jobs', label: $translate.instant('JS_SPACE.DASHBOARD.LABEL.COMPLETED_JOBS'), type: 'number' }
    ];
    var config = {
      batchOptions: {
        batch          : 1,
        isBatchReport  : false,
        isNextBatch    : false,
        isPreviousBatch: false
      },
      options: {
        identifier: 'bookings',
        title     : $translate.instant('JS_SPACE.DASHBOARD.REPORT.BOOKINGS_COMPLETED_JOBS')
      },
      unshiftDateColumn: true, // If true, be sure to account for date column in view.columns array.
      view             : {
        columns: [0, 1, 2]
      }
    };
    var rows = [];

    angular.forEach(bookingsReport, function (record, date) {
      rows.push(
        {
          c: [
            { v: date },
            { v: record.bookings },
            { v: record.finalized_invoices }
          ]
        }
      );
    });

    return googleCharts.buildReport(cols, rows, config);
  };

  var buildHoursReport = function (hoursReport, isEmpty, batch) {
    var cols = [];
    var config = {
      batchOptions: {
        batch          : batch || 1,
        isBatchReport  : false,
        isNextBatch    : false,
        isPreviousBatch: false
      },
      options: {
        identifier: 'hours',
        title     : $translate.instant('JS_SPACE.DASHBOARD.REPORT.EMPLOYEE_HOURS', {
          title: $rootScope.Company.labels.employeeTitle
        })
      },
      unshiftDateColumn: true, // If true, add 1 to cols.length when retrieving columns array.
      view             : {
        columns: []
      }
    };
    var ids = [];
    var rows = [];

    if (isEmpty) {
      cols = [
        {
          id   : 'label',
          label: $translate.instant('EMPLOYEE_SPACE.EMPLOYEES', {
             title: $rootScope.Company.labels.employeeTitle
          }),
          type: 'number'
        }
      ];

      angular.forEach(hoursReport, function (records, date) {
        var row = [
          { v: date },
          { v: 0 }
        ];

        rows.push({ c: row });
      });
    }
    else {
      // Build the remaining columns (mechanics) without duplicates.
      angular.forEach(hoursReport, function (mechanics, date) {

        angular.forEach(mechanics, function (mechanic, id) {
          if (ids.indexOf(id) < 0) {
            cols.push({
              id   : id,
              label: mechanic.last_name + ', ' + mechanic.first_name,
              type : 'number'
            });

            ids.push(id);
          }
        });
      });

      // If report is a batch report, only build with the requested
      // batch of columns (mechanics).
      if (cols.length > batchSize) {
        config.batchOptions.isBatchReport = true;

        if (cols.length % batchSize) {
          config.batchOptions.isNextBatch = config.batchOptions.batch === Math.floor(cols.length / batchSize) + 1 ? false : true;
        }
        else {
          config.batchOptions.isNextBatch = config.batchOptions.batch === (cols.length / batchSize) ? false : true;
        }

        config.batchOptions.isPreviousBatch = config.batchOptions.batch === 1 ? false : true;

        cols.splice(0, ((config.batchOptions.batch - 1) * batchSize));
        cols = cols.slice(0, batchSize);
      }

      // Populate rows with data. If report is a batch report, ID
      // matching will populate only the desired batch data.
      angular.forEach(hoursReport, function (mechanics, date) {

        // Mechanics are returned for each day.
        // If a mechanic did not work on any given day, an object for that
        // mechanic/day is not returned. However, we must still provide a chart row
        // for that missing mechanic object with a value of 0.

        // Initial row object for date.
        var row = [{ v: date }];

        // For every date, check for each mechanic.
        for (var i = 0; i < cols.length; i++) {
          var flag = false;

          // For every mechanic, check for matching id.
          angular.forEach(mechanics, function (mechanic, id) {
            if (id === cols[i].id) {
              flag = true;

              row.push({
                v: mechanic.mech_hours_worked
              });
            }
          });

          if (!flag) {
            row.push({
              v: 0
            });
          }
        }

        rows.push({ c: row });
      });
    }

    // Get array of column indexes. Add 1 to length to anticipate date column.
    config.view.columns = googleCharts.buildViewColumns(cols.length + 1);

    return googleCharts.buildReport(cols, rows, config);
  };

  var buildPerformanceReport = function (performanceReport, isEmpty, batch) {
    var cols = [];
    var config = {
      batchOptions: {
        batch          : batch || 1,
        isBatchReport  : false,
        isNextBatch    : false,
        isPreviousBatch: false
      },
      options: {
        identifier: 'performance',
        title     : $translate.instant('REPORT_SPACE.NAMES.EMPLOYEE_PERFORMANCE', {
          title: $rootScope.Company.labels.employeeTitle
        })
      },
      unshiftDateColumn: true, // If true, add 1 to cols.length when retrieving columns array.
      view             : {
        columns: []
      }
    };
    var ids = [];
    var rows = [];

    if (isEmpty) {
      cols = [
        {
          id   : 'label',
          label: $translate.instant('EMPLOYEE_SPACE.EMPLOYEES', {
            title: $rootScope.Company.labels.employeeTitle
          }),
          type: 'number'
        }
      ];

      angular.forEach(performanceReport, function (records, date) {
        var row = [
          { v: date },
          { v: 0 }
        ];

        rows.push({ c: row });
      });
    }
    else {

      // Build the remaining columns (mechanics) without duplicates.
      angular.forEach(performanceReport, function (mechanics, date) {

        angular.forEach(mechanics, function (mechanic, id) {
          if (ids.indexOf(id) < 0) {
            cols.push({
              id   : id,
              label: mechanic.last_name + ', ' + mechanic.first_name,
              type : 'number'
            });

            ids.push(id);
          }
        });
      });

      // If report is a batch report, only build with the requested
      // batch of columns (mechanics).
      if (cols.length > batchSize) {
        config.batchOptions.isBatchReport = true;

        if (cols.length % batchSize) {
          config.batchOptions.isNextBatch = config.batchOptions.batch === Math.floor(cols.length / batchSize) + 1 ? false : true;
        }
        else {
          config.batchOptions.isNextBatch = config.batchOptions.batch === (cols.length / batchSize) ? false : true;
        }

        config.batchOptions.isPreviousBatch = config.batchOptions.batch === 1 ? false : true;

        cols.splice(0, ((config.batchOptions.batch - 1) * batchSize));
        cols = cols.slice(0, batchSize);
      }

      // Populate rows with data. If report is a batch report, ID
      // matching will populate only the desired batch data.
      angular.forEach(performanceReport, function (mechanics, date) {

        // Mechanics are returned for each day.
        // If a mechanic did not work on any given day, an object for that
        // mechanic/day is not returned. However, we must still provide a chart row
        // for that missing mechanic object with values of 0.

        // Initial row object for date.
        var row = [{ v: date }];

        // For every date, check for each mechanic.
        for (var i = 0; i < cols.length; i++) {
          var flag = false;

          // For every mechanic, check for matching id.
          angular.forEach(mechanics, function (mechanic, id) {
            if (id === cols[i].id) {
              flag = true;

              row.push({
                v: mechanic.profit,
                f: '\n' + $translate.instant('JS_SPACE.DASHBOARD.LABEL.PROFIT') + ': ' + $filter('globalCurrency')(mechanic.profit) +
                  '\n' + $translate.instant('PRODUCT_SPACE.CHARGED') + ': ' + $filter('globalCurrency')(mechanic.amount_charged) +
                  '\n' + $translate.instant('PRODUCT_SPACE.COST') + ': ' + $filter('globalCurrency')(mechanic.cost)
              });
            }
          });

          if (!flag) {
            row.push({
              v: 0,
              f: '\n' + $translate.instant('JS_SPACE.DASHBOARD.LABEL.PROFIT') + ': ' + $filter('globalCurrency')(0) +
                '\n' + $translate.instant('PRODUCT_SPACE.CHARGED') + ': ' + $filter('globalCurrency')(0) +
                '\n' + $translate.instant('PRODUCT_SPACE.COST') + ': ' + $filter('globalCurrency')(0)
            });
          }
        }

        rows.push({ c: row });
      });
    }

    // Get array of column indexes. Add 1 to length to anticipate date column.
    config.view.columns = googleCharts.buildViewColumns(cols.length + 1);

    return googleCharts.buildReport(cols, rows, config);
  };

  var buildProductsReport = function (productsReport) {
    var cols = [
      { id: 'subletRepair', label: $translate.instant('JS_SPACE.DASHBOARD.LABEL.SUBLET_REPAIRS'), type: 'number' },
      { id: 'labour', label: $translate.instant('GENERAL_SPACE.SWITCH.LABOUR'), type: 'number' },
      { id: 'stock', label: $translate.instant('JS_SPACE.DASHBOARD.LABEL.STOCK'), type: 'number' },
      { id: 'tyres', label: $translate.instant('JS_SPACE.DASHBOARD.LABEL.TYRES'), type: 'number' },
      { id: 'consumable', label: $translate.instant('JS_SPACE.DASHBOARD.LABEL.CONSUMABLES'), type: 'number' },
      { id: 'accessories', label: $translate.instant('JS_SPACE.DASHBOARD.LABEL.ACCESSORIES'), type: 'number' }
    ];
    var config = {
      batchOptions: {
        batch          : 1,
        isBatchReport  : false,
        isNextBatch    : false,
        isPreviousBatch: false
      },
      options: {
        identifier: 'products',
        title     : $translate.instant('JS_SPACE.DASHBOARD.REPORT.PRODUCT_DETAILS')
      },
      unshiftDateColumn: true, // If true, be sure to account for date column in view.columns array.
      view             : {
        columns: [0, 1, 2, 3, 4, 5, 6]
      }
    };
    var rows = [];

    angular.forEach(productsReport, function (products, date) {
      var row = [{ v: date }];

      // Products are returned for each day in alphabetical order by type.
      // If no product was purchased of any given type, an object for that
      // type is not returned. However, we must still provide a chart row
      // for that missing type object with values of 0.

      // For every date, check for each product type.
      for (var i = 0; i < PRODUCTTYPES.length; i++) {
        var index = -1;

        // For every product, check for matching product type. When no match, push empty values.
        for (var j = 0; j < products.length; j++) {
          if (products[j].type === PRODUCTTYPES[i]) {
            index = j;
          }
        }

        if (index !== -1) {
          row.push({
            v: products[index].sales,
            f: '\n' + $translate.instant('MENU_SPACE.REPORTS.SALES') + ': ' + $filter('globalCurrency')(products[index].sales) +
              '\n' + $translate.instant('PRODUCT_SPACE.COST') + ': ' + $filter('globalCurrency')(products[index].cost)
          });
        }
        else {
          row.push({
            v: 0,
            f: '\n' + $translate.instant('MENU_SPACE.REPORTS.SALES') + ': ' + $filter('globalCurrency')(0) +
              '\n' + $translate.instant('PRODUCT_SPACE.COST') + ': ' + $filter('globalCurrency')(0)
          });
        }
      }

      rows.push({ c: row });
    });

    return googleCharts.buildReport(cols, rows, config);
  };

  var buildSalesReport = function (salesReport) {
    var cols = [
      { id: 'sales', label: $translate.instant('MENU_SPACE.REPORTS.SALES'), type: 'number' },
      { id: 'cost', label: $translate.instant('PRODUCT_SPACE.COST'), type: 'number' },
      { id: 'profit', label: $translate.instant('JS_SPACE.DASHBOARD.LABEL.PROFIT'), type: 'number' }
    ];
    var config = {
      batchOptions: {
        batch          : 1,
        isBatchReport  : false,
        isNextBatch    : false,
        isPreviousBatch: false
      },
      options: {
        identifier: 'sales',
        title     : $translate.instant('REPORT_SPACE.NAMES.SALES_REPORT')
      },
      unshiftDateColumn: true, // If true, be sure to account for date column in view.columns array.
      view             : {
        columns: [0, 1, 2, 3]
      }
    };
    var rows = [];

    angular.forEach(salesReport, function (invoice, date) {
      rows.push(
        {
          c: [
            { v: date },
            {
              v: invoice.invoice_totals,
              f: $filter('globalCurrency')(invoice.invoice_totals)
            },
            {
              v: invoice.total_cost,
              f: $filter('globalCurrency')(invoice.total_cost)
            },
            {
              v: invoice.total_profit,
              f: $filter('globalCurrency')(invoice.total_profit)
            }
          ]
        }
      );
    });

    return googleCharts.buildReport(cols, rows, config);
  };

  var getFirstOfMonth = function () {
    var date = new Date();

    return new Date(date.getFullYear(), date.getMonth(), 1);
  };

  var getLastOfMonth = function () {
    var date = new Date();

    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  };

  var getOneWeekBeforeDate = function (date) {
    date = moment(date, 'DD-MM-YYYY');
    date = date.subtract(7, 'days');

    return moment(date).format('DD-MM-YYYY');
  };

  var getOneWeekFromDate = function (date) {
    date = moment(date, 'DD-MM-YYYY');
    date = date.add(7, 'days');

    return moment(date).format('DD-MM-YYYY');
  };

  var pad = function (digit) {
    return (digit < 10) ? '0' + digit : digit;
  };

  // Mechanics begin_time is in UTC. Need to convert to local time depending on user's location.
  Dashboard.prototype.configureMechanics = function (mechanics) {
    var utcOffset = moment().zone();

    angular.forEach(mechanics, function (mechanic) {
      var date = mechanic.begin_time.split('T')[0];
      var date_with_utc = moment(mechanic.begin_time, 'YYYY-MM-DD HH:mm:ss').subtract(utcOffset, 'minutes').format('MMM D, YYYY');
      var time = mechanic.begin_time.split('T')[1];

      time = moment(time, 'hh:mm:ss').subtract(utcOffset, 'minutes').format('h:mm A');
      mechanic.begin_time = $filter('date')(date_with_utc) + ' ' + time;
    });

    return mechanics;
  };

  Dashboard.prototype.displayAdvertisement = function () {
    var settings = sessionObjAPI.systemSettings();

    return settings ? !settings.hide_dashboard_ad : true;
  };

  Dashboard.prototype.fullDashboardPrivileges = function () {
    return sessionObjAPI.user().dashboard_privileges === 'F';
  };

  Dashboard.prototype.getBookingsReport = function () {
    var self = this;

    return workshopAPI.get('/dashboard/bookings_and_jobs', self.getStartOfWeek(new Date()))
      .then(function (bookingsReport) {
        return buildBookingsReport(bookingsReport.data);
      }, function (err) {
        return $q.reject(err);
      });
  };

  Dashboard.prototype.getBookingUrl = function (booking) {
    if (booking.vehicle_id) {
      return sprintf('/%1$s/%2$s/event/%3$s', booking.customer_id, booking.vehicle_id, booking.id);
    }
    else {
      return sprintf('/%1$s/event/%2$s', booking.customer_id, booking.id);
    }
  };

  Dashboard.prototype.getHoursReport = function () {
    var self = this;

    return workshopAPI.get('/dashboard/mechanic_hours', self.getStartOfWeek(new Date()))
      .then(function (hoursReport) {
        return buildHoursReport(hoursReport.data, hoursReport.is_empty);
      }, function (err) {
        return $q.reject(err);
      });
  };

  Dashboard.prototype.getInvoiceUrl = function (job) {
    if (job.job_vehicle_id || job.vehicle_id) {
      return sprintf('/%1$s/%2$s/invoice/%3$s', job.job_customer_id || job.customer_id, job.job_vehicle_id || job.vehicle_id, job.job_id || job.invoice_id);
    }
    else {
      return sprintf('/%1$s/invoice/%2$s', job.job_customer_id || job.customer_id, job.job_id || job.invoice_id);
    }
  };

  Dashboard.prototype.getNextBatchReport = function (report) {
    var self = this;
    var identifier = report.options.identifier;
    var params = [report.data.rows[0].c[0].v];

    identifier === 'sales' ? params.push(self.widgets_include_tax.toString()) : null;

    return workshopAPI.get(self.routes[identifier], params).then(function (data) {
      return self.builds[identifier](data.data, data.is_empty, report.batchOptions.batch + 1);
    }, function (err) {
      return $q.reject(err);
    });
  };

  Dashboard.prototype.getNextWeeksReport = function (report) {
    var self = this;
    var identifier = report.options.identifier;
    var params = [getOneWeekFromDate(report.data.rows[0].c[0].v)];

    identifier === 'sales' ? params.push(self.widgets_include_tax.toString()) : null;

    return workshopAPI.get(self.routes[identifier], params).then(function (data) {
      return self.builds[identifier](data.data, data.is_empty);
    }, function (err) {
      return $q.reject(err);
    });
  };

  Dashboard.prototype.getPerformanceReport = function (report) {
    var self = this;

    return workshopAPI.get('/dashboard/mechanic_performance', self.getStartOfWeek(new Date()))
      .then(function (performanceReport) {
        return buildPerformanceReport(performanceReport.data, performanceReport.is_empty);
      }, function (err) {
        return $q.reject(err);
      });
  };

  Dashboard.prototype.getPreviousBatchReport = function (report) {
    var self = this;
    var identifier = report.options.identifier;
    var params = [report.data.rows[0].c[0].v];

    identifier === 'sales' ? params.push(self.widgets_include_tax.toString()) : null;

    return workshopAPI.get(self.routes[identifier], params).then(function (data) {
      return self.builds[identifier](data.data, data.is_empty, report.batchOptions.batch - 1);
    }, function (err) {
      return $q.reject(err);
    });
  };

  Dashboard.prototype.getPreviousWeeksReport = function (report) {
    var self = this;
    var identifier = report.options.identifier;
    var params = [getOneWeekBeforeDate(report.data.rows[0].c[0].v)];

    identifier === 'sales' ? params.push(self.widgets_include_tax.toString()) : null;

    return workshopAPI.get(self.routes[identifier], params).then(function (data) {
      return self.builds[identifier](data.data, data.is_empty);
    }, function (err) {
      return $q.reject(err);
    });
  };

  Dashboard.prototype.getProductsReport = function () {
    var self = this;

    return workshopAPI.get('/dashboard/sales_breakup_report', self.getStartOfWeek(new Date()))
      .then(function (productsReport) {
        return buildProductsReport(productsReport.data);
      }, function (err) {
        return $q.reject(err);
      });
  };

  Dashboard.prototype.getJasperReport = function (timespan) {
    var self = this;
    var company = sessionObjAPI.company();

    var today = moment(new Date()).format('DD-MM-YYYY');
    var pastDate = (self.widgets_mtd == true && timespan == 29) ? moment(getFirstOfMonth()).format('DD-MM-YYYY') : moment(today, 'DD-MM-YYYY').subtract(timespan, 'days').format('DD-MM-YYYY');

    $window.open(`${self.jasperRoutes['sales']}/pdf/${pastDate}/${today}/C/${company.id}.pdf`);
  };

  Dashboard.prototype.getRenewalReport = function (report) {
    var self = this;
    var company = sessionObjAPI.company();

    var startDate = moment(getFirstOfMonth()).format('DD-MM-YYYY');
    var endDate = moment(getLastOfMonth()).format('DD-MM-YYYY');

    $window.open(`${self.jasperRoutes[report]}/pdf/${startDate}/${endDate}/${company.id}.pdf`);
  };

  Dashboard.prototype.getSalesReport = function () {
    var self = this;

    return workshopAPI.get('/dashboard/weekly_sales_report', [
      self.getStartOfWeek(new Date()),
      self.widgets_include_tax.toString()
    ]).then(function (salesReport) {
      return buildSalesReport(salesReport.data);
    }, function (err) {
      return $q.reject(err);
    });
  };

  Dashboard.prototype.getStartOfWeek = function (date) {
    date.setDate(date.getDate() - date.getDay());

    return [pad(date.getDate()), pad(date.getMonth() + 1), date.getFullYear()].join('-');
  };

  Dashboard.prototype.handleTabClick = function (tab = {}) {
    const self = this;

    angular.forEach(self.tabs, function (tab) {
      tab.active = false;
    });

    self.tab = tab;

    tab.active = true;
  };

  Dashboard.prototype.hideReportSeries = function (report, selectedItem) {
    var col = selectedItem.column;

    if (selectedItem.row === null) {
      if (report.view.columns[col] == col) {
        report.view.columns[col] = {
          label: report.data.cols[col].label,
          type : report.data.cols[col].type,
          calc : function () {
            return null;
          }
        };
      }
      else {
        report.view.columns[col] = col;
      }
    }

    return report;
  };

  Dashboard.prototype.isBusinessIntelligenceTab = function ( tab = this.tab ) {
    return businessIntelligenceApi.isTabBusinessIntelligence(tab);
  };

  Dashboard.prototype.toggleChart = function (type) {
    return type === 'ColumnChart' ? 'LineChart' : 'ColumnChart';
  };

  Dashboard.prototype.toggleTaxSwitch = function () {
    var self = this;

    localStorage.setItem('dashboardTaxSwitch', angular.toJson(self.widgets_include_tax));
    $state.reload();
  };

  Dashboard.prototype.toggleMTDSwitch = function () {
    var self = this;

    localStorage.setItem('dashboardMTDSwitch', angular.toJson(self.widgets_mtd));
    $state.reload();
  };

  return Dashboard;
}